import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch } from 'react-redux';

import Header from '../layout/Header';
import Footer from '../layout/Footer';
import Sidebar from '../layout/Sidebar';
import Breadcrumbs from '../Reusables/Breadcrumbs';
import '../../scss/broadcast.scss';
import { parseBreadcrumbsList } from '../../store/Actions';
import getResponse from '../actions/Project';
import RefreshToken from '../actions/RefreshToken';
import create from '../../images/projectdetails/add.png';
import MultipleUpload from '../popups/MultipleUpload';
import trash from '../../images/common/trash.png';
import Config from '../actions/Config';
import DeleteItem from '../popups/DeleteItem';
import { CopyToClipboard } from "react-copy-to-clipboard";
import Tooltip from "@material-ui/core/Tooltip";
import getCommonResponse from '../actions/Common';
import pdfPlaceholder from '../../images/common/pdf-placeholder.png';
import { convertUTCToPST } from '../Reusables/Function';


const BASE_URL = Config();
function BroadcastFiles(props) {
    const {id} = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [idBroadcast, setIdBroadcast] = useState(null);
    const [trigger, setTrigger] = useState(false);
    const [show, setShow] = useState(false);
    const [loadend, setLoadEnd] = useState(false);
    const [uploaderror, setUploaderror] = useState('');
    const [created, setCreate] = useState(false);
    const [tooltipMessage, setTooltipMessage] = useState("Copy Link")
    const [deleteFileId, setDeleteFileId] = useState(null);
    const [filelist, setFilelist] = useState([]);

    function handleShow() {
        setShow(true);
        setLoadEnd(false);
        setUploaderror('');
        setCreate(!created);
    }

    const handleClose = () => setShow(false);

    const [showDeleteFile, setShowDeleteFile] = useState(false);
    const handleCloseDeletePopup = () => setShowDeleteFile(false);
    const handleShowDeletePopup = () => setShowDeleteFile(true);

    useEffect(() => {
        function CallAPI(accesstoken) {
            if(accesstoken === '') {
                navigate('/login');
            }
            else if(accesstoken === 'noToken') {
                navigate('/login', {state : {path : window.location.pathname+window.location.search+window.location.hash}});
            }
            else {
                const URL = `/api/Project/projectdetails/${id}`;
                getResponse.GetProjectDetails(URL, accesstoken, (response) => {  
                    if(response.status == 200) {
                        if(response.data != null) {
                            if(response.data.broadcasts != null && response.data.broadcasts.length > 0) {
                                setIdBroadcast(response.data.broadcasts[0].idBroadcast)
                                setTrigger(!trigger);
                            }
                            var breadcrumbsList = [
                                { "name": "Home", "url": "" },
                                { "name": "Projects", "url": "projects/list" },
                                { "name": `${response.data.name}`, "url": `projects/${id}/view` },
                                { "name": "Broadcast", "url": `projects/${id}/broadcast` },
                                { "name": "Files", "url": `projects/${id}/broadcast/files` },
                            ];
                            dispatch(parseBreadcrumbsList(breadcrumbsList));
                        }
                    } else if(response.status == 401) {
                        navigate("/login")
                    }
                });
            }
        }
        RefreshToken((accesstoken) => CallAPI(accesstoken));
    }, [])

    useEffect(() => {
        function CallAPI(accesstoken) {
            if(accesstoken === '') {
                navigate('/login');
            } else {
                 const URL = `/api/Project/${id}/broadcast/files`;
                getCommonResponse.GetDetailsWithToken(URL, accesstoken, (response) => {  
                    if(response.status == 200) {
                        setFilelist(response.data.data)
                    } else if(response.status == 401) {
                        navigate("/login")
                    }
                });
            }
        }
        RefreshToken((accesstoken) => CallAPI(accesstoken));
    }, [trigger])

    const DeleteFile = (e, fileid) => {
        e.stopPropagation();
        setDeleteFileId(fileid);
        handleShowDeletePopup();
    }

    const callDeleteFileApi = () => {
        const URL = `/api/Project/broadcast/file/delete/${deleteFileId}`
        function CallAPI(accesstoken) {
            if(accesstoken === '') {
                navigate('/login');
            }
            else {
                getResponse.DeleteFile(URL, accesstoken, (response) => {
                    if(response.status == 200) {
                        setTrigger(!trigger);
                        handleCloseDeletePopup();
                    } else if(response.status == 401) {
                        navigate("/login")
                    }
                });
            }
        }
        RefreshToken((accesstoken) => CallAPI(accesstoken));
    }

    const handleMouseLeave = () => {
        setTooltipMessage("Copy Link")
    }


    return (
        <div className='broadcast-images-container'>
            <Header />

            <div className='row broadcast-images-sub-container'>
                <Sidebar />

                <div className='col-10 broadcast-images-content'>
                    <Breadcrumbs />

                    <div className='broadcast-images-header'>
                        <div className='files-container'>
                            <div className='files-left'>
                                <div className='imges-header'>Files</div>
                            </div>
                            <div className='files-right'>
                                <div><img className='upload' src={create} alt='upload' onClick={handleShow}></img></div>
                                <MultipleUpload show={show} handleClose={handleClose} id={id} setUpload={setTrigger} uploadstate={trigger} setLoadEnd={setLoadEnd} loadend={loadend} 
                                created={created} pageType="Broadcast"/>
                            </div>
                        </div>
                    </div>
                    <div className='images-section'>
                        <div className='files-table'>
                            <table>
                                <thead>
                                    <tr className='heading-row'>
                                        <th className='heading-data first-data' style={{minWidth: "200px"}}>
                                            <div className='heading-arrows'>
                                                <div>Name</div>
                                            </div>
                                        </th>
                                        <th className='heading-data' style={{minWidth: "440px"}}>
                                            <div className='heading-arrows'>
                                                <div>Public Url</div>
                                            </div>
                                        </th>
                                        <th className='heading-data' style={{minWidth: "200px"}}>
                                            <div className='heading-arrows'>
                                                <div>Uploaded Date</div>
                                            </div>
                                        </th>
                                        <th className='heading-data' style={{minWidth: "170px"}}>
                                            <div className='heading-arrows'>
                                                <div>Size</div>
                                            </div>
                                        </th>
                                        <th className='heading-data action-heading' style={{width: "120px"}}>Actions</th>
                                    </tr>
                                </thead>
                                {
                                filelist.length === 0 ? <p className="no-result">No results found</p> :
                                    <tbody>
                                        { filelist && filelist.length > 0 && filelist.map((item, index) => {
                                            return (
                                                <tr className='details-list-row' key={index} onMouseLeave={handleMouseLeave}>  
                                                    <td className='details-list-data first-data' style={{minWidth: "100px"}}>
                                                        <div className='name-container'>
                                                            <div><img src={`${item.fileUrl.substring(item.fileUrl.lastIndexOf('.')+1, 
                                                            item.fileUrl.length) == "pdf" ? pdfPlaceholder : item.fileUrl}`}/></div>
                                                            <div>{item.fileName && item.fileName}</div>
                                                        </div>
                                                    </td>
                                                    <td className='details-list-data files-url' style={{minWidth: "440px"}}>
                                                        <div className='files-url-copy'>
                                                            <div>
                                                                <a target="_blank" href={`${item.fileUrl && item.fileUrl.replace('\\', '/')}`}>
                                                                    {item.fileUrl && item.fileUrl.replace('\\', '/')}
                                                                </a>
                                                            </div>
                                                            <CopyToClipboard
                                                                text={`${item.fileUrl && item.fileUrl.replace('\\', '/')}`}
                                                                onCopy = {() => setTooltipMessage("Link Copied!")}>
                                                                <span>
                                                                    <Tooltip title={tooltipMessage}>
                                                                        <div className='icon icon-copy icon-2x'></div>
                                                                    </Tooltip> 
                                                                </span>
                                                            </CopyToClipboard>                                       
                                                        </div>
                                                    </td>
                                                    <td className='details-list-data' style={{minWidth: "200px"}}>{item.uploadedDate && convertUTCToPST(item.uploadedDate + 'Z', "updates")}</td>
                                                    <td className='details-list-data' style={{minWidth: "170px"}}>{item.size && item.size}</td>
                                                    <td className='details-list-data action'>
                                                        <img className='trash' src={trash} alt="delete" onClick={(e) => DeleteFile(e, item.idFiles)}></img></td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                } 
                            </table>
                        </div>
                        {/* Showing delete popup */}
                        <DeleteItem show={showDeleteFile} handleClose={handleCloseDeletePopup} deleteApiCall={callDeleteFileApi} enable={true}/>
                    </div>
                </div>
            </div>

            <Footer /> 
        </div>
    );
}

export default BroadcastFiles;